<template>
  <svg
    class="easter-update-icon"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g class="easter-update-icon__egg">
      <path
        d="M13.6 8.39997C13.6 8.95197 13.6 9.51198 13.6 10.072C13.504 12.592 10.968 15.304 7.71201 15.416C6.5638 15.4872 5.42821 15.1437 4.51201 14.448C3.90844 13.9913 3.40372 13.4169 3.02834 12.7597C2.65297 12.1024 2.41472 11.3759 2.32801 10.624C2.19987 9.6168 2.25681 8.59469 2.49601 7.60798C2.89424 5.77824 3.64709 4.04425 4.71201 2.50397C5.21199 1.76878 5.91136 1.19152 6.72801 0.839975C7.1225 0.658504 7.55335 0.56991 7.98744 0.581005C8.42153 0.5921 8.8473 0.702588 9.23201 0.903975C10.4817 1.49691 11.4676 2.53135 12 3.80798C12.1711 4.25288 12.377 4.68355 12.616 5.09598C13.005 5.84988 13.2748 6.65947 13.416 7.49598C13.472 7.78398 13.504 8.07997 13.552 8.37597L13.6 8.39997Z"
        fill="#FAFAFF"
      />
      <path
        d="M11.288 11.824C11.288 11.904 11.288 11.944 11.288 11.968C10.8041 12.6933 10.1205 13.2629 9.31977 13.6079C8.51903 13.9529 7.63547 14.0585 6.77598 13.912C6.16526 13.7801 5.60052 13.4884 5.13948 13.0667C4.67845 12.6451 4.33767 12.1085 4.15198 11.512C6.4219 12.443 8.94546 12.5534 11.288 11.824Z"
        fill="#142ACC"
      />
      <path
        d="M12.0001 8.49609C12.0001 9.00809 12.0001 9.44009 12.0001 9.89609C11.2621 10.3303 10.4472 10.6183 9.60014 10.7441C7.90165 11.0136 6.16179 10.8145 4.56814 10.1681C3.64014 9.78409 3.57614 9.67209 3.76814 8.65609C5.06725 9.23782 6.47891 9.52514 7.90205 9.49748C9.32519 9.46982 10.7246 9.12786 12.0001 8.49609Z"
        fill="#142ACC"
      />
      <path
        d="M11.7042 7.01611C9.06416 8.57611 5.52817 8.15211 4.14417 7.20811C4.20017 7.00811 4.24816 6.7841 4.32016 6.5761C4.39216 6.3681 4.48016 6.15211 4.57616 5.89611C6.82416 6.69611 9.04016 7.00011 11.3042 5.80811C11.4562 6.25611 11.5842 6.64011 11.7042 7.01611Z"
        fill="#142ACC"
      />
      <path
        d="M10.6639 4.43993C9.44787 5.35193 6.76787 5.43993 5.11987 4.60793C5.45867 3.76544 5.9838 3.01057 6.65587 2.39993C6.93773 2.20147 7.26817 2.08326 7.61195 2.05789C7.95573 2.03253 8.29995 2.10098 8.60787 2.25593C9.49345 2.76542 10.2087 3.52523 10.6639 4.43993Z"
        fill="#142ACC"
      />
    </g>
  </svg>
</template>
